module.exports = __webpack_public_path__ + "static/media/LMC1.c01d9fe2.png";